import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-ignore: side-effect import for CSS handled by bundler
import './styles/app.css';
import { Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import UploadPhotos from './pages/UploadPhotos';
import Entry from './pages/Entry';
import Entries from './pages/Entries';
import NotFound from './pages/NotFound';
import Manage from './pages/Manage';
var App = function () {
    return (_jsx(_Fragment, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Home, {}) }), _jsx(Route, { path: "/quote/:slug/upload", element: _jsx(UploadPhotos, {}) }), _jsx(Route, { path: "/quote/:slug", element: _jsx(Entry, {}) }), _jsx(Route, { path: "/entries/:pageNo", element: _jsx(Entries, {}) }), _jsx(Route, { path: "/entry/:slug", element: _jsx(Manage, {}) }), _jsx(Route, { path: "*", element: _jsx(NotFound, {}) })] }) }));
};
export default App;
